
const parseParams: (data: string) => { [key: string]: string } = function (data: string = ''): { [key: string]: string } {
    let str: string = data
    const ret: { [key: string]: string } = {}
    if (data && (data[0] === '?')) {
        str = data.slice(1)
    }

    let paramsArr: any[] = str.split('&')
    paramsArr = paramsArr.map(item => {
        return item.split('=')
    })

    for (let i = 0; i < paramsArr.length; i++) {
        const item = paramsArr[i];
        ret[`${item[0]}`] = item.filter((i, idx) => idx !== 0).join('=')
    }

    return ret
}
export default parseParams 